<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="life">
<h1>Life</h1>
<p><strong><em>Life, intolerance, while time slips quickly by</em></strong></p>
<p style="text-indent:0em"><strong><em>The frosted glass of fate.</em></strong></p>
<p style="text-indent:0em"><strong><em>Sweet memories of incompatibility</em></strong></p>
<p style="text-indent:0em"><strong><em>Change to despair and shadowed death.</em></strong></p><br/>
<p style="text-indent:0em"><strong><em>For what purpose do we live?</em></strong></p>
<p style="text-indent:0em"><strong><em>Knowing of eternal beauty and splendour</em></strong></p>
<p style="text-indent:0em"><strong><em>Waiting just around the corner.</em></strong></p>
<p style="text-indent:0em"><strong><em>To this there can be no answering.</em></strong></p><br/>
<p style="text-indent:0em"><strong><em>One pattern, one path incomplete</em></strong></p>
<p style="text-indent:0em"><strong><em>Desiring, love, lust demolished! Returned to dust.</em></strong></p>
<p style="text-indent:0em"><strong><em>Now one and all to cry, repeat!</em></strong></p><br/>
<p style="text-indent:0em">RAS 1966–1968</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?40586f90